"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_USER_AGENT = void 0;
const VERSION = "21.11.0";
const URL = 'https://github.com/prezly/javascript-sdk';
const DEFAULT_USER_AGENT = exports.DEFAULT_USER_AGENT = `prezly-javascript-sdk/${VERSION} (+${URL})`;